import styled from 'styled-components';
import { colors, heading4, spacing } from 'ui/theme';
import { Takeover } from 'ui/workflows/takeover';
import { TakeoverDrawer } from 'ui/workflows/takeover/Takeover.styles';

export const StyledTakeover = styled(Takeover)`
  z-index: 10000;
`;

export const WithdrawnDrawerTakeover = styled(StyledTakeover)`
  ${TakeoverDrawer} {
    width: calc(100% - ${spacing.x16});
    margin-left: ${spacing.x16};
  }
`;

export const TakeoverHeaderBarContent = styled.div`
  ${heading4}
  color: ${colors.white};
`;

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${spacing.half} ${spacing.base};
  width: 100%;
`;

export const BodyWrapper = styled.div`
  min-height: 100%;
  padding-left: ${spacing.half};
  position: relative;
`;

export const BodyHeader = styled.div`
  ${heading4}
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${spacing.base};
`;
